// Network health icons
import { ReactComponent as NetworkHealthIcon } from '../../assets/NetworkHealthIcon.svg';
// Airplane health icons
import { ReactComponent as AirplaneHealthIcon } from '../../assets/AirplaneHealthIcon.svg';
// Software health icons
import { ReactComponent as SoftwareHealthIcon } from '../../assets/SoftwareHealthIcon.svg';
// Content health icons
import { ReactComponent as ContentHealthIcon } from '../../assets/ContentHealthIcon.svg';


import {
  Grid,
  Stack,
} from '@mui/material';
import { create } from '@mui/material/styles/createTransitions';

const createExplanationTooltip = (explanation) => {
  return (
    <Stack>
      {(explanation ?? '').split('\n').map((line, index) => (
        <Grid key={index} item>{line}</Grid>
      ))}
    </Stack>
  )
}

export const getIconStyling = (activeStatus, serialNumber) => {
  const isFBO = serialNumber && serialNumber.startsWith("SX-")
  
  // Set defaults -- Error / Offline case
  var styles = {
    textColor: '#AEB1B4',
    aircraftStatusColor: '#D52D34',
    aircraftIcon: <AirplaneHealthIcon color='#D52D34' />,
    aircraftTooltip: null,
    softwareStatusColor: '#D52D34',
    softwareIcon: <SoftwareHealthIcon color='#D52D34' />,
    softwareTooltip: null,
    contentStatusColor: '#D52D34',
    contentIcon: <ContentHealthIcon color='#D52D34' />,
    contentTooltip: null,
    networkIcon: <NetworkHealthIcon height={30} width={30} color='#D52D34' />, // error color
    networkTooltip: null,
  };

  switch (activeStatus?.networkHealth) {
    case 'Healthy':
      styles.networkIcon = <NetworkHealthIcon height={30} width={30} color='#52B35B' />;
      if (isFBO) {
        styles.networkTooltip = createExplanationTooltip("VPN is up\nLast status received less than an hour ago\nAll AP's online and a client connection established in the last hour")
      } else {
        styles.networkTooltip = createExplanationTooltip("Last status message received less than 7 days ago")
      }
      break;
    case 'Warning':
      styles.networkIcon = <NetworkHealthIcon height={30} width={30} color='#EAAB00' />;
      styles.networkTooltip = createExplanationTooltip(activeStatus?.networkExplanation);
      break;
    case 'Error':
    default:
      // Default to Error case
      styles.networkIcon = <NetworkHealthIcon height={30} width={30} color='#D52D34' />;
      styles.networkTooltip = createExplanationTooltip(activeStatus?.networkExplanation);
      break;
  }

  switch (activeStatus?.aircraftSyncHealth) {
    case 'Healthy':
      styles.aircraftStatusColor = '#52B35B';
      styles.aircraftIcon = <AirplaneHealthIcon color='#52B35B' />;
      if (isFBO) {
        styles.aircraftTooltip = 'Aircraft seen in the last 24 hours';
      } else {
        styles.aircraftTooltip = 'Last aircraft seen in less than a month';
      }
      break;
    case 'Warning':
      styles.aircraftStatusColor = '#EAAB00';
      styles.aircraftIcon = <AirplaneHealthIcon color='#EAAB00' />;
      styles.aircraftTooltip = createExplanationTooltip(activeStatus?.aircraftSyncExplanation);
      break;
    case 'Error':
    default:
      // Default to Error case
      styles.aircraftStatusColor = '#D52D34';
      styles.aircraftIcon = <AirplaneHealthIcon color='#D52D34' />;
      styles.aircraftTooltip = createExplanationTooltip(activeStatus?.aircraftSyncExplanation);
      break;
  }

  switch (activeStatus?.visionContentHealth) {
    case 'Healthy':
      styles.contentStatusColor = '#52B35B';
      styles.contentIcon = <ContentHealthIcon color='#52B35B' />;
      styles.contentTooltip = 'Content is up to date';
      break;
    case 'Warning':
      styles.contentStatusColor = '#EAAB00';
      styles.contentIcon = <ContentHealthIcon color='#EAAB00' />;
      styles.contentTooltip = createExplanationTooltip(activeStatus?.visionContentExplanation);
      break;
    case 'Error':
    default:
      // Default to Error case
      styles.contentStatusColor = '#D52D34';
      styles.contentIcon = <ContentHealthIcon color='#D52D34' />;
      styles.contentTooltip = createExplanationTooltip(activeStatus?.visionContentExplanation);
      break;
  }

  switch (activeStatus?.softwareVersionHealth) {
    case 'Healthy':
      styles.softwareStatusColor = '#52B35B';
      styles.softwareIcon = <SoftwareHealthIcon color='#52B35B' />;
      styles.softwareTooltip = 'Software is up to date';
      break;
    case 'Warning':
      styles.softwareStatusColor = '#EAAB00';
      styles.softwareIcon = <SoftwareHealthIcon color='#EAAB00' />;
      styles.softwareTooltip = createExplanationTooltip(activeStatus?.softwareVersionExplanation);
      break;
    case 'Error':
    default:
      // Default to Error case
      styles.softwareStatusColor = '#D52D34';
      styles.softwareIcon = <SoftwareHealthIcon color='#D52D34' />;
      styles.softwareTooltip = createExplanationTooltip(activeStatus?.softwareVersionExplanation);
      break;
  }

  return styles;
};